import axios from "axios";
import AppSettings from "../appsettings";

const BASE_URL = `${AppSettings.API_BASE_URL}/publishers`;

const PublisherApiService = {
  // ✅ Get all publishers
  getAllPublishers: async () => {
    try {
      const response = await axios.get(`${BASE_URL}/GetAll`);
      return response.data;
    } catch (error) {
      console.error("❌ Failed to fetch publishers:", error);
      throw error;
    }
  },

  // ✅ Get a single publisher by ID
  getPublisherById: async (id) => {
    try {
      const response = await axios.get(`${BASE_URL}/Get/${id}`);
      return response.data;
    } catch (error) {
      console.error(`❌ Failed to fetch publisher ID ${id}:`, error);
      throw error;
    }
  },

  // ✅ Create a new publisher
  createPublisher: async (publisher) => {
    try {
      const response = await axios.post(`${BASE_URL}/Create`, publisher);
      return response.data;
    } catch (error) {
      console.error("❌ Failed to create publisher:", error);
      throw error;
    }
  },

  // ✅ Update an existing publisher
  updatePublisher: async (id, publisher) => {
    try {
      const response = await axios.put(`${BASE_URL}/Update/${id}`, publisher);
      return response.status === 204;
    } catch (error) {
      console.error(`❌ Failed to update publisher ID ${id}:`, error);
      throw error;
    }
  },

  // ✅ Send dashboard credentials email to a new publisher
  sendDashboardCredentials: async ({ customerName, email, username, password }) => {
    const response = await axios.post(
      `${AppSettings.API_BASE_URL}/Email/send-dashboard-credentials`,
      {
        customerName,
        email,
        dashboardUrl: "https://www.portalad.adblastx.com/",
        username,
        password,
      }
    );
    return response.data;
  },

  // ✅ Delete a publisher
  deletePublisher: async (id) => {
    try {
      const response = await axios.delete(`${BASE_URL}/Delete/${id}`);
      return response.status === 204;
    } catch (error) {
      console.error(`❌ Failed to delete publisher ID ${id}:`, error);
      throw error;
    }
  },
};

export default PublisherApiService;
